export const asTime = {
  data: `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.33333 3.33333V6.66667L8.16667 8.34667L8.68 7.49333L6.33333 6.1V3.33333H5.33333ZM12 4.66667V0L10.24 1.76C9.16 0.673333 7.66 0 6 0C2.68667 0 0 2.68667 0 6C0 9.31333 2.68667 12 6 12C9.31333 12 12 9.31333 12 6H10.6667C10.6667 8.57333 8.57333 10.6667 6 10.6667C3.42667 10.6667 1.33333 8.57333 1.33333 6C1.33333 3.42667 3.42667 1.33333 6 1.33333C7.28667 1.33333 8.45333 1.86 9.3 2.7L7.33333 4.66667H12Z" fill="#818F99"/>
  </svg>
  `,
  name: 'time',
};
